var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMembershipCardButtonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 12,
    viewBox: "0 0 25 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.5645,
    width: 11.1906,
    height: 11.1885,
    rx: 1.39856,
    fill: "#1C1C1E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.918 5.59338C12.918 5.16427 12.9554 4.81641 13.0016 4.81641H20.0079C20.054 4.81641 20.0915 5.16427 20.0915 5.59338C20.0915 6.0225 20.054 6.37036 20.0079 6.37036H13.0016C12.9554 6.37036 12.918 6.0225 12.918 5.59338Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2323 1.47677C17.4249 1.26816 17.7372 1.26816 17.9298 1.47677L21.382 5.21598C21.5746 5.42458 21.5746 5.7628 21.382 5.97141L17.9298 9.71062C17.7372 9.91923 17.4249 9.91923 17.2323 9.71062C17.0397 9.50201 17.0397 9.16379 17.2323 8.95519L20.3358 5.59369L17.2323 2.2322C17.0397 2.02359 17.0397 1.68538 17.2323 1.47677Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.869141 5.59351C0.869141 5.07857 0.936504 4.66113 1.0196 4.66113H13.6309C13.714 4.66113 13.7814 5.07857 13.7814 5.59351C13.7814 6.10844 13.714 6.52588 13.6309 6.52588H1.0196C0.936504 6.52588 0.869141 6.10844 0.869141 5.59351Z",
    fill: "#1C1C1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembershipCardButtonIcon);
export default __webpack_public_path__ + "static/media/membership-card-button-icon.9432210b8331dd2871fffa69e4b3922e.svg";
export { ForwardRef as ReactComponent };